var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"id":"GlobalMap","space":"0"}},[_c('div',{ref:"map",staticClass:"map",style:(_vm.map)})])}
var staticRenderFns = []

export { render, staticRenderFns }